var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCheckboxIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.91665 13.2948L14.5192 7.69229L13.641 6.8141L8.91665 11.5385L6.54165 9.16346L5.66346 10.0416L8.91665 13.2948ZM4.50642 17.1666C4.08547 17.1666 3.72917 17.0208 3.4375 16.7291C3.14583 16.4375 3 16.0812 3 15.6602V4.50642C3 4.08547 3.14583 3.72917 3.4375 3.4375C3.72917 3.14583 4.08547 3 4.50642 3H15.6602C16.0812 3 16.4375 3.14583 16.7291 3.4375C17.0208 3.72917 17.1666 4.08547 17.1666 4.50642V15.6602C17.1666 16.0812 17.0208 16.4375 16.7291 16.7291C16.4375 17.0208 16.0812 17.1666 15.6602 17.1666H4.50642ZM4.50642 15.9166H15.6602C15.7243 15.9166 15.7831 15.8899 15.8365 15.8365C15.8899 15.7831 15.9166 15.7243 15.9166 15.6602V4.50642C15.9166 4.44231 15.8899 4.38354 15.8365 4.3301C15.7831 4.27669 15.7243 4.24998 15.6602 4.24998H4.50642C4.44231 4.24998 4.38353 4.27669 4.3301 4.3301C4.27669 4.38354 4.24998 4.44231 4.24998 4.50642V15.6602C4.24998 15.7243 4.27669 15.7831 4.3301 15.8365C4.38353 15.8899 4.44231 15.9166 4.50642 15.9166Z",
    fill: "#344054"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckboxIcon);
export default __webpack_public_path__ + "static/media/checkbox-icon.547c20efd9a2a255eab52f9a5bd834a7.svg";
export { ForwardRef as ReactComponent };